import React from "react";

import DrupalOAuth from "../utils/DrupalOAuth";

const initialState = {};
export const AuthContext = React.createContext(initialState);

const reducer = (state, action) => {
	switch (action.type) {
		case "AUTHENTICATE_USER":
			return {
				...state,
				isAuthenticated: true,
			};
		case "LOGOUT_USER":
			return {
				...state,
				isAuthenticated: false,
			};
		default:
			return state;
	}
};

export const AuthContextProvider = (props) => {
	const auth = new DrupalOAuth(props);
	const state = { ...initialState, isAuthenticated: auth.isLoggedIn() };

	if (props.clientId) {
		state.clientId = props.clientId;
	}
	if (props.baseUrl) {
		state.baseUrl = props.baseUrl;
	}

	const [authState, dispatch] = React.useReducer(reducer, state);
	return (
		<AuthContext.Provider
			value={[
				{
					...authState,
				},
				dispatch,
			]}
		>
			{props.children}
		</AuthContext.Provider>
	);
};
